import {ComponentProps} from 'react';
import {ReactCountryFlag} from 'react-country-flag';
import {twMerge} from 'tailwind-merge';

type RoundedCountryFlagType = {
  countryCode: string;
} & Pick<ComponentProps<'svg'>, 'className'>;

function RoundedCountryFlag({countryCode, className}: RoundedCountryFlagType) {
  return (
    <ReactCountryFlag
      svg
      alt={countryCode}
      countryCode={countryCode.toUpperCase()}
      title={countryCode}
      className={twMerge('h-full w-full rounded-full object-cover', className)}
    />
  );
}

export default RoundedCountryFlag;
